import styled from 'styled-components';
import { colors, smallShadow, spacing } from 'ui/theme';
import { pxToRem } from 'utils/convert';
import {
  ACTIVE_LOGO_CLASS_NAME,
  DESKTOP_MENU_MIN_BREAKPOINT,
  MOBILE_MENU_MAX_BREAKPOINT,
  NAVBAR_VARIANTS,
} from './constants';
import { NavLogo } from './components/NavLogo';
import { LogoVariants } from 'ui/logo';

export const NavbarContainer = styled.div`
  display: grid;
  grid-template-areas: 'logo trigger menus';
  /* adding 1fr to trigger/links area pushes menus to the right automatically */
  grid-template-columns: auto 1fr auto;
  align-items: center;
  padding-right: ${spacing.half};
  padding-left: ${spacing.base};
  gap: ${spacing.base};
  background-color: ${colors.white};
  ${smallShadow}

  &[data-variant=${NAVBAR_VARIANTS.NOVA}] {
    box-shadow: none;
    backdrop-filter: blur(24px);
    background: rgb(250 250 250 / 0.1);
  }

  @media (min-width: 768px) {
    padding-right: ${spacing.plusHalf};
    padding-left: ${spacing.double};
  }

  @media (min-width: ${DESKTOP_MENU_MIN_BREAKPOINT}) {
    grid-template-areas: "logo links menus";
  }
`;

export const LogoContainer = styled.div`
  height: 100%;
`;

export const StyledNavLogo = styled(NavLogo)`
  grid-area: logo;
  /* adding padding makes logo same height as nav items (40px); */
  padding-top: ${spacing.eighth};
  padding-bottom: ${spacing.eighth};
  height: 100%;
  /* add margin to provide proper spacing above/below */
  margin-top: ${spacing.threeQuarter};
  margin-bottom: ${spacing.threeQuarter};

  &&&[data-variant=${`${LogoVariants.DIAMOND_BORDERED}-link`}] {
    margin: 0;
    display: flex;
    justify-content: center;
    align-items: center;

    &::before {
      content: "";
      position: absolute;
      bottom: 0;
      height: ${spacing.quarter};
      border-radius: ${spacing.quarter} ${spacing.quarter} 0 0;

      --selected-state-marker-width: ${pxToRem(32)};
      width: var(--selected-state-marker-width);
      left: calc((100% - var(--selected-state-marker-width)) / 2);
    }

    &.${ACTIVE_LOGO_CLASS_NAME} {
      &::before {
        background-color: ${colors.purple100};
      }
    }
  }
`;

export const NavbarLinksContainer = styled.div`
  grid-area: links;

  @media (max-width: ${MOBILE_MENU_MAX_BREAKPOINT}) {
    display: none;
  }
`;

export const HamburgerMenuTriggerContainer = styled.div`
  grid-area: trigger;

  @media (min-width: ${DESKTOP_MENU_MIN_BREAKPOINT}) {
    display: none;
  }
`;

export const NavbarMenuContainer = styled.div`
  grid-area: menus;
`;
